import React from 'react';
import SearchAPI from '../../library/SearchAPI';
import { formatMessage } from '../../CurrentLocale';
import { Wrapper } from './style';
import Download from '../../assets/images/download-solid-full.svg';

function csvEscape(value, sep) {
  var str = String(value == null ? '' : value);
  var needsWrap =
    str.indexOf(sep) !== -1 || str.indexOf('"') !== -1 || /\r|\n/.test(str);
  var v = str.replace(/"/g, '""');
  return needsWrap ? '"' + v + '"' : v;
}

function toCell(v) {
  if (v == null) return '/';

  if (Array.isArray(v)) {
    return v.length > 0 ? v.join(' | ') : '/';
  }

  var s = String(v).trim();
  return s === '' ? '/' : s;
}

function isExclusifStrict(v) {
  return String(v || '').toLowerCase() === 'exclusif';
}
function isExclusive(v) {
  var s = String(v || '').toLowerCase();
  return s === 'exclusive' || s === 'exclusif';
}

function formatAccessType(v, lang) {
  if (v == null) return '';
  var s = String(v).toLowerCase();
  if (s === 'openaccess') return lang === 'en' ? 'Open Access' : 'Accès ouvert';
  if (s === 'freemium') return 'Freemium';
  if (s === 'exclusive' || s === 'exclusif')
    return lang === 'en' ? 'Exclusive' : 'Exclusif';
  return String(v);
}

function loadPermission(via, url, platformId) {
  if (isExclusive(via)) {
    const searchParams = new URLSearchParams(window.location.search);
    return SearchAPI.getPermissions([url], searchParams.get('pf') || 'OB').then(function(response) {
      if (response && response.data && response.data.docs) {
        console.log('response', response.data.docs[0]);
        return !!response.data.docs[0].isPermitted;
      }
      return false;
    });
  }
  return Promise.resolve(true);
}

var __permCache = {};
function getPermissionCached(via, url, platformId) {
  if (!url) return Promise.resolve(null);
  var key =
    String(isExclusive(via)) + '::' + String(platformId) + '::' + String(url);
  if (__permCache[key]) return __permCache[key];
  __permCache[key] = loadPermission(via, url, platformId).catch(function() {
    return false;
  });
  return __permCache[key];
}

function firstExisting(obj, keys) {
  for (var i = 0; i < keys.length; i++) {
    var k = keys[i];
    if (obj && obj[k]) return obj[k];
  }
  return null;
}

function buildCSVWithHeaders(rows, headerKeys, labelsMap, separator) {
  var titles = headerKeys
    .map(function(k) {
      return csvEscape(labelsMap[k] || k, separator);
    })
    .join(separator);

  var dataLines = rows.map(function(r) {
    return headerKeys
      .map(function(key) {
        return csvEscape(toCell(r[key]), separator);
      })
      .join(separator);
  });

  return '\uFEFF' + [titles].concat(dataLines).join('\r\n');
}

var headers = [
  'naked_titre',
  'ep_isbnprint',
  'ep_isbnelec',
  'url',
  'first_author',
  'site_title',
  'type',
  'anneedatepubli',
  'datemisenligne',
  'access_type',
  'monograph_volume'
];

var columnLabelsFr = {
  naked_titre: 'Titre',
  ep_isbnprint: 'EAN papier',
  ep_isbnelec: 'EAN numérique',
  url: 'URL',
  first_author: 'Premier auteur',
  site_title: 'Nom du site',
  type: 'Type',
  anneedatepubli: 'Année de publication papier',
  datemisenligne: 'Date de mise en ligne',
  access_type: 'Accès',
  monograph_volume: 'Volume de monographie'
};

var columnLabelsEn = {
  naked_titre: 'Title',
  ep_isbnprint: 'EAN (print version)',
  ep_isbnelec: 'Digital EAN',
  url: 'URL',
  first_author: 'First author',
  site_title: 'Site title',
  type: 'Type',
  anneedatepubli: 'Print publication year',
  datemisenligne: 'Online publication date',
  access_type: 'Access',
  monograph_volume: 'Monograph volume'
};

var typeLabelsFr = {
  post: 'Billet',
  article: 'Article',
  chapitre: 'Chapitre',
  compterendu: 'Compte-rendu',
  evenements: 'Évènements',
  numerorevue: 'Numéro de revue',
  livre: 'Livre',
  editorial: 'Éditorial',
  other: 'Autre'
};

var typeLabelsEn = {
  post: 'Post',
  article: 'Article',
  chapitre: 'Chapter',
  compterendu: 'Review',
  evenements: 'Events',
  numerorevue: 'Issue',
  livre: 'Book',
  editorial: 'Editorial',
  other: 'Other'
};

function mergeLabels(a, b) {
  var out = {};
  for (var k in a)
    if (Object.prototype.hasOwnProperty.call(a, k)) out[k] = a[k];
  if (b)
    for (var k2 in b)
      if (Object.prototype.hasOwnProperty.call(b, k2)) out[k2] = b[k2];
  return out;
}

function downloadText(text, filename, mime) {
  var type = mime || 'text/csv;charset=utf-8';
  var blob = new Blob([text], { type: type });
  var URL_ = window.URL || window.webkitURL;
  var url = URL_.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  if (a.remove) a.remove();
  else a.parentNode.removeChild(a);
  URL_.revokeObjectURL(url);
}

function formatDateByLang(isoDate, lang) {
  if (!isoDate) return '';

  const date = new Date(isoDate);
  if (isNaN(date)) return isoDate;

  return lang === 'en'
    ? date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })
    : date.toLocaleDateString('fr-FR');
}

class ExportCSVButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isExporting: false };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    var searchParams = new URLSearchParams(window.location.search);
    var lang = searchParams.get('l') || 'fr';
    var self = this;
    var data = this.props.data || [];
    var filename =
      'export_resultats_search_' +
      new Date().toISOString().slice(0, 10) +
      '.csv';
    var columnLabels = lang === 'en' ? columnLabelsEn : columnLabelsFr;
    var labels = mergeLabels(columnLabels, this.props.columnLabels);
    var separator = this.props.separator || ';';

    this.setState({ isExporting: true });

    var rowPromises = data.map(function(r) {
      var rawAccess = r && r.access_type != null ? r.access_type : r && r.via;
      var htmlUrl = firstExisting(r, ['html_url', 'url_html', 'url']);
      var pdfUrl = firstExisting(r, [
        'pdf_url',
        'url_pdf',
        'epub_url',
        'url_epub',
        'url'
      ]);
      var platformId = r && r.platformID;
      var needPerm = isExclusifStrict(rawAccess);
      var htmlPermPromise = needPerm
        ? getPermissionCached(rawAccess, htmlUrl, platformId)
        : Promise.resolve(true);
      console.log('htmlPermPromise', htmlPermPromise, rawAccess, htmlUrl);
      var pdfPermPromise = needPerm
        ? getPermissionCached(rawAccess, pdfUrl, platformId)
        : Promise.resolve(true);

      return Promise.all([htmlPermPromise, pdfPermPromise]).then(function(
        perms
      ) {
        var out = {};
        for (var k in r) {
          if (Object.prototype.hasOwnProperty.call(r, k)) out[k] = r[k];
        }

        if (out.datemisenligne) {
          out.datemisenligne = formatDateByLang(out.datemisenligne, lang);
        }

        out.type =
          lang === 'en' ? typeLabelsEn[out['type']] : typeLabelsFr[out['type']];
        out['access_type'] = formatAccessType(rawAccess, lang);

        return out;
      });
    });

    Promise.all(rowPromises)
      .then(function(rows) {
        var csv = buildCSVWithHeaders(rows, headers, labels, separator);
        downloadText(csv, filename);
      })
      .catch(function(err) {
        if (typeof console !== 'undefined' && console.error) console.error(err);
      })
      .then(function() {
        self.setState({ isExporting: false });
      });
  }

  render() {
    var isExporting = this.state.isExporting;
    return (
      <Wrapper>
        <button
          type="button"
          onClick={this.handleClick}
          className="button--export"
          disabled={isExporting}
          aria-busy={isExporting ? 'true' : 'false'}
        >
          <img
            className="button--export__img"
            src={Download}
            alt={formatMessage({ id: 'exportCSV.button' })}
            loading="lazy"
          />
          {isExporting
            ? formatMessage({ id: 'exportCSV.loading' }) || 'Export...'
            : formatMessage({ id: 'exportCSV.button' })}
        </button>
      </Wrapper>
    );
  }
}

export default ExportCSVButton;



// WEBPACK FOOTER //
// ./src/components/ExportCSVButton/index.js